module.exports = __webpack_public_path__ + "img/profile-icon.ebae3e40.svg";